<template>
    <div class=" index-div-content news-info-content product-info-div">
        <div class="  company-news-info">
            <div>
                <h3>{{companyNew.title}}</h3>
                <p>{{companyNew.time}}</p>
                <p class="news-content" v-html="companyNew.content"></p>

            </div>
            <el-divider></el-divider>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12">
                    <div style="min-height: 1px">
                        <router-link v-if="preNew.id" :to='"/company/news/"+preNew.id' class="news-a">
                            上一篇 <span :title="preNew.title">{{preNew.title.length>20?(preNew.title.substr(0,20)+"..."):preNew.title}}</span>
                        </router-link>

                    </div>

                </el-col>
                <el-col :xs="24" :sm="12" class="right">
                    <div style="min-height: 1px">
                        <router-link v-if="nextNew.id" :to='"/company/news/"+nextNew.id' class="news-a">
                            下一篇 <span :title="nextNew.title">{{nextNew.title.length>20?(nextNew.title.substr(0,20)+"..."):nextNew.title}}</span>
                        </router-link>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>

</template>

<script>
    import CompanyNews from "../../json/CompanyNews";

    export default {
        watch: {
            '$route'(to, form) {
                this.getNews(to.params.id)
            }
        },
        name: "info",
        data() {
            return {
                news: CompanyNews.news,
                companyNew: {},
                preNew: {},
                nextNew: {}
            }
        },
        mounted() {
            this.getNews(this.$route.params.id)
        },
        methods: {
            getNews(id) {
                this.news.sort((a, b) => {
                    return a.id - b.id
                })
                this.preNew = {}
                this.nextNew = {}
                this.companyNew = {}
                if (this.news.length > 1) {
                    for (var i = 0; i < this.news.length; i++) {
                        if (this.news[i].id == id) {
                            if (i == 0) {
                                this.nextNew = this.news[i + 1]
                            } else if (i == this.news.length - 1) {
                                this.preNew = this.news[i - 1]
                            } else {
                                this.nextNew = this.news[i + 1]
                                this.preNew = this.news[i - 1]
                            }
                        }
                    }
                }
                this.companyNew = this.news.find(item => item.id == id)
            }
        }
    }
</script>
<style lang="scss">
    .news-image {

        img {
            width: 100%;

        }
    }
    .news-content {p{
        margin-bottom: 20px;
    }}
</style>
<style scoped lang="scss">



</style>